module.exports = __webpack_public_path__ + "img/preview.6f829291.png";